import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { PageResponse } from '@core/shared/domain';
import { QueryParams } from '@core/shared/util';
import { PlatformSupplierBasic } from '@mpsm/shared/domain';

@Injectable({ providedIn: 'root' })
export class PlatformSuppliersService {
  private readonly http: HttpClient = inject(HttpClient);

  private readonly baseApiPath = '/api/contentmanagement/platform-suppliers';

  getAllPlatformSuppliers(searchTerm: string): Observable<PageResponse<PlatformSupplierBasic>> {
    const params = QueryParams.build<PlatformSupplierBasic>().param('searchTerm', searchTerm).toHttpParams();

    return this.http.get<PageResponse<PlatformSupplierBasic>>(`${this.baseApiPath}`, { params });
  }
}
